import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterJoin'
})
export class FilterJoinPipe implements PipeTransform {

  transform(value: any[], separator: string = ', '): string {
    if (!Array.isArray(value)) {
      return '';
    }
    return value.filter(e => e && e !== "").join(separator);
  }

}